import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { IntercomService } from '../services/Intercom';
import { useNavigateWithSecureParams } from './useNavigateWithSecureParams';
import { logAppDynamicsEvent, clearAppDynamicsIdentity } from '../AppDynamics';

export const useAuthActions = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const { clearParams } = useNavigateWithSecureParams();
  const idToken = auth.user?.id_token;

  const logout = () => {
    logAppDynamicsEvent('UserLogout', { message: 'User logged out' });
    clearAppDynamicsIdentity();
    queryClient.invalidateQueries();
    window.sessionStorage.clear();
    clearParams();
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: idToken });
    IntercomService.clearSession();
  };

  return { auth, logout };
};
